export default "/images/vendor/flag-icons/flags/4x3/eac.svg?3cf4691bfb7a96178880977a5d335203";